import React from 'react';
import { PropTypes } from 'prop-types';
import removeInvalidHtmlChars from 'common/App/removeInvalidHtmlChars';

const ImyNode = ({ node, showWithholdingRates }) => {
  let nodeType = 'BO';
  nodeType = (node.formType && node.formType.indexOf('imy') !== -1) || (node.children !== null && node.children.length > 0) ? 'IMY' : nodeType;
  nodeType = (node.structureId) ? 'ROOT' : nodeType;
  const nodeName = node.name;
  const ratesExist = node.filteredRates != null && node.filteredRates.length > 0;

  return (<React.Fragment>
    <span className="rst__rowTitleItem">{ (!node.name || node.name.length <= 40 ? node.name ?? 'NOT GIVEN' : `${ node.name.substring(0, 39) }...`) }</span>
    { node.attributes != null && Object.keys(node.attributes).map((a) => {
      if (node.attributes[a] && a !== 'Income Allocation') {
        return <span className="rst__rowTitleItem rst__rowSubTitle" key={ a.replace(/\s/g, '').toLowerCase() }>
          { a }: { (node.attributes[a]?.length <= 40 ? node.attributes[a] : `${ node.attributes[a].substring(0, 39) }...`) }
        </span>;
      }
      return null;
    }) }
    { showWithholdingRates && !ratesExist && <span>No Rates</span> }
    { showWithholdingRates && ratesExist && <React.Fragment>
      { nodeType === 'ROOT' && <div className="rst__rowRates rst__rowImyRates rst__rowSubTitle" data-testid={ removeInvalidHtmlChars(`${ nodeName }`) }>
        <h2>Blended Rates</h2>
        <div className="rst_colHeaders rst__rowIncomeType">
          <span className="rst__typeLabel">Payment Type</span>
          <span className="rst__colStmtAlloc">Whs. Alloc.</span>
          <span className="rst__colAlloc">Tier Alloc.</span>
          <span className="rst__colBldRate">Blended Rate</span>
          <span className="rst__colSc">State</span>
        </div>
        { node.filteredRates.map(rate => <div data-testid={ removeInvalidHtmlChars(`${ rate.paymentType }`) } className="rst__rowIncomeType" key={ `${ node.id }-${ rate.paymentType.replace(/\s/g, '') }` }>
          <span className="rst__typeLabel">{ rate.paymentType }</span>
          <span className="rst__colStmtAlloc">{ rate.stmtIncomeAllocation ?? 'N/A' }</span>
          <span className="rst__colAlloc">{ rate.blendedIncomeAllocation ?? 'N/A' }</span>
          <span className="rst__colBldRate">{ rate.blendedRate ?? 'N/A' }</span>
          <span className="rst__colSc">{ rate.state ?? 'N/A' }</span>
        </div>) }
      </div> }
      { nodeType === 'IMY' && <div className="rst__rowRates rst__rowImyRates rst__rowSubTitle" data-testid={ removeInvalidHtmlChars(`${ nodeName }`) }>
        <h2>Blended Rates</h2>
        <div className="rst_colHeaders rst__rowIncomeType">
          <span className="rst__typeLabel">Payment Type</span>
          <span className="rst__colStmtAlloc">Whs. Alloc.</span>
          <span className="rst__colAlloc">Tier Alloc.</span>
          <span className="rst__colBldRate">Blended Rate</span>
          <span className="rst__colBr">Breakout Rate</span>
          <span className="rst__colSc">State</span>
        </div>
        { node.filteredRates.map(rate => <div data-testid={ removeInvalidHtmlChars(`${ rate.paymentType }`) } className="rst__rowIncomeType" key={ `${ node.id }-${ rate.paymentType.replace(/\s/g, '').toLowerCase() }` }>
          <span className="rst__typeLabel">{ rate.paymentType }</span>
          <span className="rst__colStmtAlloc">{ rate.stmtIncomeAllocation ?? 'N/A' }</span>
          <span className="rst__colAlloc">{ rate.incomeAllocation ?? 'N/A' }</span>
          <span className="rst__colBldRate">{ rate.blendedRate ?? 'N/A' }</span>
          <span className="rst__colBr">{ rate.blendedBreakoutRate ?? 'N/A' }</span>
          <span className="rst__colSc">{ rate.state ?? 'N/A' }</span>
        </div>) }
      </div> }
      { nodeType === 'BO' && <div className="rst__rowRates rst__rowBoRates rst__rowSubTitle" data-testid={ removeInvalidHtmlChars(`${ nodeName }`) }>
        <h2>Breakout Rates</h2>
        <div className="rst_colHeaders rst__rowIncomeType">
          <span className="rst__typeLabel">Payment Type</span>
          <span className="rst__colStmtAlloc">Whs. Alloc.</span>
          <span className="rst__colAlloc">Tier Alloc.</span>
          <span className="rst__colRate">Whd. Rate</span>
          <span className="rst__colBr">Breakout Rate</span>
          <span className="rst__colSc">State</span>
          <span className="rst__colWhdType">Whd. Type</span>
        </div>
        { node.filteredRates.map((rate, i) => <div data-testid={ removeInvalidHtmlChars(`${ rate.paymentType }`) } className="rst__rowIncomeType" key={ `${ node.id }-${ rate.paymentType.replace(/\s/g, '').toLowerCase() }` }>
          <span className="rst__typeLabel">{ rate.paymentType }</span>
          <span className="rst__colStmtAlloc">{ rate.stmtIncomeAllocation ?? 'N/A' }</span>
          <span className="rst__colAlloc">{ rate.incomeAllocation ?? 'N/A' }</span>
          <span className="rst__colRate" data-testid="lbl-whd-rate">{ rate.rate ?? 'N/A' }</span>
          <span className="rst__colBr">{ rate.breakoutRate ?? 'N/A' }</span>
          <span className="rst__colSc">{ rate.state ?? 'N/A' }</span>
          <span className="rst__colWhdType" data-testid="lbl-whd-type">{ rate.whdType ?? 'N/A' }</span>
        </div>) }
      </div> }
    </React.Fragment> }
  </React.Fragment>);
};

ImyNode.propTypes = {
  node: PropTypes.shape().isRequired,
  showWithholdingRates: PropTypes.bool
};

ImyNode.defaultProps = {
  showWithholdingRates: false
};

export default ImyNode;
